module.exports = __webpack_public_path__ + "static/media/whatsapp.c008573a.png";